// Awraq writes every number with Western digits. Plain "ar-SA" formatting switches to Arabic-Indic digits,
// so Arabic formatting goes through this locale, which keeps Arabic conventions and forces Latin numerals.
export const ARABIC_WESTERN_DIGITS_LOCALE = "ar-SA-u-nu-latn";

export const formatCount = (value: number): string => value.toLocaleString(ARABIC_WESTERN_DIGITS_LOCALE);

export const formatArabicDate = (date: string | Date): string =>
  new Date(date).toLocaleDateString(ARABIC_WESTERN_DIGITS_LOCALE);
